<template>
  <!-- 添加图文直播 -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="toAdDas"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col>
            <el-form-item label="标题" prop="title">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.title"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="描述" prop="raffleDesc">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.raffleDesc"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="toAdDas.startDate"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="toAdDas.endDate"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px; margin-top: 50px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
     
    </div>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["AddData"],
  data() {
    return {
      value1: "", //查询时间
      menuDas: [],
      //添加的参数：
      toAdDas: {
        title: "", // 标题
        raffleDesc: "", //摘要
        name: "", //奖项名称
        maxTimes: "", //奖品数量
        winTimes: "", //已中奖数量,
        rank: "", //排名
      },

      toAdRule: {
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        raffleDesc: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        createDate: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        type: [{ required: true, message: "内容不能为空", trigger: "change" }],
      },
    };
  },
  methods: {
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    //新增：
    submitAdd(formName) {
      if (this.toAdDas.startDate) {
        var startDate = this.formatDate(new Date(this.toAdDas.startDate));
      }
      if (this.toAdDas.endDate) {
        var endDate = this.formatDate(new Date(this.toAdDas.endDate));
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/raffle/insert", {
            title: this.toAdDas.title, //标题
            startDate: startDate,
            raffleDesc: this.toAdDas.raffleDesc, //摘要
            endDate: endDate,
          }).then((res) => {
            if (res.success == true) {
                this.$router.push({ path: "/lucky" });
              this.$message.success(res.message);
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
    // submitAdd2() {
    //   this.postAxios("/raffle/add/option", {
    //     name: this.toAdDas.name,
    //     maxTimes: this.toAdDas.maxTimes,
    //     winTimes: this.toAdDas.winTimes,
    //     rank: this.toAdDas.rank,
        
    //   }).then((res) => {
    //     if (res.success == true) {
    //       //   this.$router.push({ path: "/lucky" });
    //       this.$message.success(res.message);
    //     } else if (res.success == false) {
    //       this.$message.error(res.message);
    //     } else if (!res.success && res.statusCode == "401") {
    //       this.$message.error(res.message);
    //       this.$router.push("/");
    //     }
    //   });
    // },
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>